/**
 * activityPages — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {A4, tagline, chips, type ToilePack} from './data'

export const activityPagesPack: ToilePack = {
    slug: 'activity-pages',
    category: 'activity',
    name: 'Kids activity pages',
    tagline: tagline('pages', 'puzzles', 'themes'),
    chips: chips('puzzles', 'themes'),
    ratio: A4,
    readings: [
        {key: 'maze', label: 'Maze', subject: 'a winding corridor maze with one entrance and one exit'},
        {key: 'dots', label: 'Dot-to-dot', subject: 'a character reduced to a numbered trail of dots'},
        {key: 'ispy', label: 'I-spy', subject: 'a seek-and-find scene with a find-these icon row'},
    ],
    styles: [
        {key: 'jungle', label: 'Jungle', style: 'monkeys, toucans, a sleepy tiger, palms and vines', palette: 'black line only, pure white ground', framing: 'full page, centered, white margin'},
        {key: 'space', label: 'Outer space', style: 'rockets, ringed planets, an astronaut, grinning stars', palette: 'black line only, pure white ground', framing: 'full page, centered, white margin'},
        {key: 'ocean', label: 'Under the sea', style: 'a turtle, clownfish, an octopus, coral and seaweed', palette: 'black line only, pure white ground', framing: 'full page, centered, white margin'},
    ],
    directions: ['a dinosaur theme', 'easier, for a five-year-old', 'with a small answer key'],
}
